import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 分页拉取物料库
export const queryMpmsSpuList = async (data) => {
  return request(`${UrlConfig.MpmsWeb.QueryMpmsSpuList}?pageId=${data.pageId}&pageSize=${data.pageSize}`, {
    method: METHODS.POST,
    data
  })
}

// 物料库-分类树
export const queryMpmsCategoryList = async (data) => {
  return request(UrlConfig.MpmsWeb.QueryMpmsCategoryList, {
    method: METHODS.POST,
    data
  })
}

// 物料库-选择提交
export const chooseSubmit = async (data, callback = (progress: any) => {}) => {
  return request(UrlConfig.MpmsWeb.ChooseSubmit, {
    method: METHODS.POST,
    data,
    onUploadProgress: (e) => {
      if (typeof e.progress !== 'undefined') {
        callback(e.progress * 100)
      }
    },
  })
}

// 物料库-全部提交
export const allSubmit = async (data, callback = (progress: any) => {}) => {
  return request(UrlConfig.MpmsWeb.AllSubmit, {
    method: METHODS.POST,
    data,
    onUploadProgress: (e) => {
      if (typeof e.progress !== 'undefined') {
        callback(e.progress * 100)
      }
    },
  })
}

// 物料命名方式枚举
export const prodCombCreateTypeEnum = async () => {
  return request(UrlConfig.MpmsWeb.ProdCombCreateTypeEnum, {
    method: METHODS.GET,
  })
}

// 物料库-分类树
export const checkSpuAndCache = async (data) => {
  return request(UrlConfig.MpmsWeb.CheckSpuAndCache, {
    method: METHODS.POST,
    data
  })
}

// 组合检查查数据
export const getSpuCachePage = async (options: any) => {
  return request(UrlConfig.MpmsWeb.GetSpuCachePage, {
    method: METHODS.POST,
    ...options
  })
}

// 服务设置查询
export const getCacheSpuSerListBySpuId = async (query: any) => {
  return request(UrlConfig.MpmsWeb.GetCacheSpuSerListBySpuId, {
    method: METHODS.GET,
    params: query,
  })
}

// 服务设置保存
export const saveMaterialAndProdSerCache = async (data) => {
  return request(UrlConfig.MpmsWeb.SaveMaterialAndProdSerCache, {
    method: METHODS.POST,
    data
  })
}

// 组合检查提交
export const materialToProdCombSubmit = async (data) => {
  return request(UrlConfig.MpmsWeb.MaterialToProdCombSubmit, {
    method: METHODS.POST,
    data
  })
}

// 组合检查取消清除缓存
export const cleanMaterialToProdCombCache = async (query: any) => {
  return request(UrlConfig.MpmsWeb.CleanMaterialToProdCombCache, {
    method: METHODS.GET,
    params: query,
  })
}